// extracted by mini-css-extract-plugin
module.exports = {"cardTooltip":"cardTooltip_cardTooltip__3eItj","cardBack":"cardTooltip_cardBack__3kYWG","card":"cardTooltip_card__2NETg","loader":"cardTooltip_loader__aHgtR"};